/* The benchmark figures the blog posts quote, derived once from
   `benchmark.json`.

   Five posts read the same file, and a range like "44% to 58%" computed in
   each would be five places for the rounding to disagree. **Nothing here is
   typed**: every number comes from the file `bin/rails research:benchmark`
   writes, and the sentences that name an industry are held against it by
   `benchmark_post_test`. */
import benchmark from '~/marketing/research/benchmark.json';

export { benchmark };
/* `ALL` is every industry measured; `I` is the ten the benchmark post covers,
   as published on 2026-10-13. Every total, range and "ten industries" below is
   the post's, so the post and the guides quoting it keep describing what they
   described; the industry pages and cards read any industry through `by`. */
export const ALL = benchmark.industries;
export const I = ALL.filter(i => benchmark.post.includes(i.key));
export const by = Object.fromEntries(ALL.map(i => [i.key, i]));

export const pct = (n, of) => Math.round((1000 * n) / of) / 10;
export const span = values => [Math.min(...values), Math.max(...values)];
const sum = f => I.reduce((n, i) => n + f(i), 0);
export const listingShare = i => pct(i.citations.listings, i.citations.of);
export const ownShare = i => pct(i.citations.business_sites, i.citations.of);

export const count = n => n.toLocaleString('en-US');
// One decimal place everywhere a figure has one, so 5.0 does not print as 5.
export const one = n => n.toFixed(1);
const WORDS = ['no', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten',
  'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen', 'twenty'];
export const word = n => WORDS[n] ?? count(n);
export const range = ([a, b], unit = '') => (a === b ? `${a}${unit}` : `${a}${unit} to ${b}${unit}`);
export const and = items => items.join(', ').replace(/, ([^,]*)$/, ' and $1');
const whole = ([a, b]) => [Math.round(a), Math.round(b)];

export const totals = {
  answers: sum(i => i.answers),
  named: sum(i => i.named.count),
  asked: sum(i => i.named.of),
  adviceNamed: sum(i => i.advice.count),
  advice: sum(i => i.advice.of),
};

export const ranges = {
  named: span(I.map(i => pct(i.named.count, i.named.of))),
  perAnswer: span(I.map(i => i.named_per_answer)),
  overlap: span(I.map(i => i.repeat_overlap)),
  listings: span(I.map(listingShare)),
  own: span(I.map(ownShare)),
};

// The shapes the guide posts print: whole percentages, one-decimal counts.
export const said = {
  industries: word(I.length),
  cities: and(benchmark.metros.map(m => m.split(',')[0])),
  engines: and(benchmark.engines),
  dates: and([...new Set(I.map(i => i.measured_on))]),
  namedAtLeast: Math.floor(ranges.named[0]),
  perAnswer: range(ranges.perAnswer.map(one)),
  overlap: range(ranges.overlap, '%'),
  listings: range(whole(ranges.listings), '%'),
  own: range(whole(ranges.own), '%'),
};

// The most ways one in-home senior care brand was written in a city.
export const homeCareSpellings = Math.max(...by.home_care.cities.map(c => c.most_spellings.names));
